// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { isEqual } from 'lodash';

import type { CategoryArticleType } from 'types/Article';
import { getPublicAssets } from 'utils/assetsUtils';
import CardThumbnail from 'containers/fragments/CardThumbnailContainer';
import { type CardMenuElementType, nullHighlightedTeams } from 'types/Settings';

export type StateProps = {
  categoriesArticle: CategoryArticleType[],
  equipes_une: CardMenuElementType[],
  equipes_une_titre: string,
  equipes_une_description: string,
  equipes_une_cta: string,
  equipes_une_lien: string,
};

export default class Team extends PureComponent<StateProps> {
  renderTeamCategories = () => {
    const { equipes_une } = this.props;
    
    return equipes_une.map<any>(({ title, description, object_slug, texte_cta, featured_image }) => {
      let img = featured_image.src || getPublicAssets('/img/trash/card.jpg');
      if (featured_image.sizes && featured_image.sizes.medium_large && featured_image.sizes.medium_large.src) {
        img = featured_image.sizes.medium_large.src;
      }
      return (
        <div key={title} className='col col-md-4 col-lg-4 mb-2 mb-md-0'>
          <CardThumbnail
            desc={description}
            url={`equipes/${object_slug}`}
            title={title}
            backgroundUrl={{src: img}}
            linkLabel={texte_cta} />
        </div>
      );
    });
  };

  render() {
    const { renderTeamCategories } = this;
    const { equipes_une, equipes_une_titre, equipes_une_description, equipes_une_lien, equipes_une_cta } = this.props;
    const notHydrated = isEqual(equipes_une, nullHighlightedTeams);

    if (!notHydrated) {
      return (
        <>
          {equipes_une_lien &&
          <Link
            to={equipes_une_lien}
            className='link-chevron link-chevron--right section__link section__link--zIndex mt-1'>
            <span>{equipes_une_cta}</span>
            <i className='icon icon-chevron-right' />
          </Link>}
          <h2 className='mb-3'>{equipes_une_titre}</h2>
          <p className="mb-3">{equipes_une_description}</p>
          <div className='row'>
            {renderTeamCategories()}
          </div>
        </>
      );
    }
    return null;
  }
}
